export default __webpack_public_path__ + "static/media/fm-logo.ef410351.svg";